/**
 * Loads the build-time PokéAPI snapshot and builds lookup indexes.
 *
 * The JSON is referenced as an asset URL (not inlined) so Vite emits it as
 * a hashed file that the service worker precaches — the species list, dex
 * lists and game list are therefore available on the very first offline
 * launch, before any detail fetch happens.
 */
const snapshotUrl = new URL('./snapshot.json', import.meta.url);

let cached;

export async function loadSnapshot() {
  if (cached) return cached;
  const res = await fetch(snapshotUrl);
  if (!res.ok) throw new Error(`Failed to load data snapshot (${res.status})`);
  const data = await res.json();

  data.speciesById = new Map(data.species.map((s) => [s.id, s]));
  data.pokedexByKey = new Map(data.pokedexes.map((d) => [d.key, d]));
  data.versionGroupByKey = new Map(data.versionGroups.map((v) => [v.key, v]));
  data.generationById = new Map(data.generations.map((g) => [g.id, g]));
  data.moves = data.moves || [];
  data.items = data.items || [];
  data.abilities = data.abilities || [];
  data.berries = data.berries || [];
  data.moveById = new Map(data.moves.map((m) => [m.id, m]));
  data.itemById = new Map(data.items.map((it) => [it.id, it]));
  data.abilityById = new Map(data.abilities.map((a) => [a.id, a]));
  data.berryById = new Map(data.berries.map((b) => [b.id, b]));
  data.itemCategories = [...new Set(data.items.map((it) => it.category))].sort();

  cached = data;
  return cached;
}
